<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (cancel)="cancel()"
  (confirm)="confirm($event)"
  data-test="edit-machining-depth"
>
  <div class="spacing--margin-top">
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'machiningDepth' | translate }} (cm)</mat-label>
        <input
          matInput
          agrNumber
          maxlength="2"
          [placeholder]="'machiningDepth' | translate"
          formControlName="machiningDepthInCentimeters"
          [min]="0"
          [step]="1"
          data-test="edit-cropfield-machiningDepthInCentimeters"
        />
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
